import {
  BLE,
  Window,
  iOSConnectSuccessResults,
  ReceivedValueListener
} from '@/types/ble'
import { BleDeviceTypes } from '@/constants/ble'
import ecgMockGenerator from './mockGenerators/ecg'
import * as gens from './mockGenerators/index'

type BLEMock = BLE & {}

const t2a = {
  [BleDeviceTypes.ELECTRONIC_BLOOD_PRESSURE_MONITOR]:
    'ELECTRONIC_BLOOD_PRESSURE_MONITOR',
  [BleDeviceTypes.MEDICAL_BLOOD_PRESSURE_MONITOR]:
    'MEDICAL_BLOOD_PRESSURE_MONITOR',
  [BleDeviceTypes.ELECTRONIC_THERMOMETER]: 'ELECTRONIC_THERMOMETER',
  [BleDeviceTypes.BLOOD_SUGAR_LEVEL_MEASUREMENT]:
    'BLOOD_SUGAR_LEVEL_MEASUREMENT',
  [BleDeviceTypes.SPO2_MONITOR_MIGHTY_SAT]: 'SPO2_MONITOR_MIGHTY_SAT',
  [BleDeviceTypes.ECG_SERVICE]: 'ECG_SERVICE',
  [BleDeviceTypes.SPO2_MONITOR_TM1121]: 'SPO2_MONITOR_TM1121',
  [BleDeviceTypes.NONCONTACT_THERMOMETER]: 'NONCONTACT_THERMOMETER',
  [BleDeviceTypes.BODY_COMPOSITION_MONITOR]: 'BODY_COMPOSITION_MONITOR'
}

export const bleMockInit = (testDeviceTypes: Array<BleDeviceTypes>) => {
  const disconnectCallbacks: {
    [address: string]: () => void
  } = {}
  const receviedValueListeners: {
    [address: string]: ReceivedValueListener<BleDeviceTypes>
  } = {}
  const generator = (address: string) => {
    switch (address) {
      case 'ECG_SERVICE':
        return ecgMockGenerator.next().value
      case 'ELECTRONIC_BLOOD_PRESSURE_MONITOR':
        return gens.electronicBloodPressureMonitorGenerator.next().value
      case 'MEDICAL_BLOOD_PRESSURE_MONITOR':
        return gens.medicalBloodPressureMonitorGenerator.next().value
      case 'ELECTRONIC_THERMOMETER':
        return gens.electronicThermometerGenerator.next().value
      case 'BLOOD_SUGAR_LEVEL_MEASUREMENT':
        return gens.bloodSugarLevelMeasurementGenerator.next().value
      case 'SPO2_MONITOR_MIGHTY_SAT':
        return gens.spo2MonitorMightySatGenerator.next().value
      case 'SPO2_MONITOR_TM1121':
        return gens.spo2MonitorTm1121Generator.next().value
      case 'NONCONTACT_THERMOMETER':
        return gens.noncontactThermometerGenerator.next().value
      case 'BODY_COMPOSITION_MONITOR':
        return gens.bodyCompositionMonitorGenerator.next().value
    }
  }

  let notifyLoop: number | null = null

  const startNotifyLoop = () => {
    notifyLoop = setInterval(() => {
      Object.keys(receviedValueListeners).forEach(address => {
        // const data = generator(address) as any
        // console.log(address, data)
        // eslint-disable-next-line
        receviedValueListeners[address](generator(address) as any)
      })
    }, 100)
  }

  const stopNotiryLoop = () => {
    if (notifyLoop !== null) {
      clearInterval(notifyLoop)
    }
  }

  const Ble: BLEMock = {
    foundDevices: [],

    init(handleSuccess, handleError) {
      return new Promise<{ status: string }>(resolve => {
        resolve({ status: 'initialized' })
      }).then(handleSuccess, handleError)
    },

    startScan(addDevice) {
      testDeviceTypes.reduce((sequence, deviceType) => {
        console.log('Scaned deviceType: ', deviceType)
        const findDevice = () => {
          return new Promise<void>(resolve => {
            setTimeout(() => {
              addDevice(t2a[deviceType], t2a[deviceType])
              resolve()
            }, 100)
          })
        }
        return sequence.then(findDevice)
      }, Promise.resolve())
    },

    stopScan() {
      return new Promise(resolve => resolve())
    },

    connect(address, handleSuccess, handleError, disconnectCallback) {
      disconnectCallbacks[address] = disconnectCallback

      startNotifyLoop()

      return new Promise<iOSConnectSuccessResults | undefined>(resolve => {
        resolve()
      }).then(handleSuccess, handleError)
    },

    close(address, handleSuccess, handleError) {
      stopNotiryLoop()
    },

    disconnect(address, handleSuccess, handleError) {
      stopNotiryLoop()

      return new Promise(resolve => resolve()).then(handleSuccess, handleError)
    },

    addReceivedValueListener(address, listener) {
      receviedValueListeners[address] = listener
    },

    changeNC1BLEConfig(address, handleSuccess, handleError) {
      return new Promise(resolve => resolve()).then(handleSuccess, handleError)
    },

    isNumber1Device(name) {
      return name === t2a[BleDeviceTypes.ELECTRONIC_BLOOD_PRESSURE_MONITOR]
    },

    isNumber2Device(name) {
      return name === t2a[BleDeviceTypes.MEDICAL_BLOOD_PRESSURE_MONITOR]
    },

    isNumber3Device(name) {
      return name === t2a[BleDeviceTypes.ELECTRONIC_THERMOMETER]
    },

    isNumber4Device(name) {
      return name === t2a[BleDeviceTypes.BLOOD_SUGAR_LEVEL_MEASUREMENT]
    },

    isNumber5Device(name) {
      return name === t2a[BleDeviceTypes.SPO2_MONITOR_MIGHTY_SAT]
    },

    isNumber6Device(name) {
      return name === t2a[BleDeviceTypes.ECG_SERVICE]
    },

    isNumber7Device(name) {
      return name === t2a[BleDeviceTypes.SPO2_MONITOR_TM1121]
    },

    isNumber9Device(name) {
      return name === t2a[BleDeviceTypes.NONCONTACT_THERMOMETER]
    },

    isNumber10Device(name) {
      return name === t2a[BleDeviceTypes.BODY_COMPOSITION_MONITOR]
    }
  }
  ;(window as Window).Ble = Ble
}
